import React, { useEffect, useState } from "react"
import UploadFiles from "@pages/etlDirectory/upload"
import ListDirectory from "@pages/etlDirectory/listDirectory"
import { Button, Col, Row, Typography } from "antd"
import EtlDirMenu from "@pages/etlDirectory/menu"

const EtlDirectoryPage = ({}) => {
  const [showUpload, setShowUpload] = useState(false)
  const [currentPath, setCurrentPath] = useState("")

  return (
    <>
      <Row
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: -10,
        }}
      >
        <Typography.Title level={5} style={{ marginTop: "5px" }}>
          File Explorer
        </Typography.Title>
      </Row>

      <EtlDirMenu
        setShowUpload={setShowUpload}
        showUpload={showUpload}
        currentPath={currentPath}
      />

      <Row gutter={10} style={{ minHeight: "100%" }}>
        <Col span={showUpload ? 16 : 24}>
          <ListDirectory
            currentPath={currentPath}
            setCurrentPath={setCurrentPath}
          />
        </Col>

        {showUpload && (
          <Col span={8} style={{ borderLeft: "1px solid black" }}>
            <UploadFiles
              setShowUpload={setShowUpload}
              currentPath={currentPath}
            />
          </Col>
        )}
      </Row>
    </>
  )
}

export default EtlDirectoryPage
